export default __webpack_public_path__ + "static/media/Winhacks.bb8ec42e.png";